import { INavigationSectionFragment, useFeatureNavigationQuery } from 'generated/sanity-graphql';

interface IUseFeatureNavigationValue {
  featureNavigationLoading: boolean;
  aboutMenuEntries: INavigationSectionFragment | null;
}

export const useFeatureNavigation = (): IUseFeatureNavigationValue => {
  const FEATURE_NAVIGATION_SINGLETON_ID = 'feature-navigation-singleton';

  const { data, loading } = useFeatureNavigationQuery({
    variables: { featureNavigationId: FEATURE_NAVIGATION_SINGLETON_ID },
  });

  const { navigationMobile } = data?.FeatureNavigation ?? {};

  return {
    aboutMenuEntries: navigationMobile?.aboutMenuEntries ?? null,
    featureNavigationLoading: loading,
  };
};
